import { mutator } from 'satcheljs';
import { onPanelOpenChanged } from '../actions';
import { getAdunitStore } from '../store/store';

mutator(onPanelOpenChanged, (msg) => {
  getAdunitStore().isPanelOpen = msg.isPanelOpen;
  getAdunitStore().scriptProps = { propertyId: msg.activePropertyId!, adunitId: msg.activeAdUnitId! };
});
